module.exports = __webpack_public_path__ + "img/guanli.13dbc397.png";